import { Column, Editing, Item, RequiredRule, Toolbar } from 'devextreme-react/data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';


export const SevkiyatTipi = () => {
    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    const ref = useRef();
    const mountedRef = useRef(true);
    let skipValidationCheck = false;

    useEffect(() => {
        fetchData();
        return () => {
            mountedRef.current = false;
        };
    }, []);

    const loadDataRef = (type) => {
        if (type) {
            ref.current.instance.beginCustomLoading();
        } else {
            ref.current.instance.endCustomLoading();
        }
    }


    const fetchData = async () => {
        loadDataRef(true);
        try {
            const response = await api.post("shippingType/getAll");
            if (mountedRef.current) {
                setDataSources(response.data.data || []);
            }
        } catch (error) {
            toast.error("Hata oluştu");
            console.error("Error fetching shipping types:", error);
        } finally {
            loadDataRef(false);
        }
    };

    const addModel = async (data, e) => {
        loadDataRef(true);
        data.create_user_id = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        data.brand_id = 10;

        try {
            const response = await api.post("shippingType/create", data);
            if (response.status === 200) {
                skipValidationCheck = true;
                toast.success(t("Ekleme başarılı"));
                await fetchData();
            }
        } catch (error) {
            console.error("Error adding shipping type:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
            loadDataRef(false);
        }
    };

    const updateModel = async (e, data) => {
        loadDataRef(true);
        const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        const body = { ...data.oldData, ...data.newData, update_user_id: employeeId };

        try {
            const response = await api.post("shippingType/update", body);
            if (response.status === 200) {
                skipValidationCheck = true;
                toast.success(t("Güncelleme başarılı"));
                await fetchData();
            }
        } catch (error) {
            console.error("Error updating shipping type:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
            loadDataRef(false);
        }
    };

    const onRowValidating = (e) => {
        if (e.brokenRules.length === 0) {
            if (skipValidationCheck) {
                e.isValid = true;
                skipValidationCheck = false;
                return;
            }

            e.isValid = false;
            if (!e.oldData) {
                addModel(e.newData, e);
            } else {
                updateModel(e, e);
            }
        }
    };

    return (
        <>
            <Breadcrumb current="Sevkiyat Tipi" />
            <Card className="p-4">
                <DatagridCustom
                    dataSource={dataSources}
                    reff={ref}
                    onRowValidating={onRowValidating}
                    onInitNewRow={(e) => {
                        e.data.is_active = true;
                        e.component.__addingStart = true;
                    }}
                >
                    {/* <LoadPanel
                        height={100}
                        width={250}
                        indicatorSrc={CustomLoadPanel}

                    /> */}
                    <Editing
                        mode="row"
                        popup={{
                            title: t("Yeni Sevkiyat Tipi"),
                            showTitle: true,
                            width: 700,
                            height: "auto",
                        }}
                        allowUpdating
                        allowAdding
                        useIcons
                    />
                    <Column dataField="type_code" caption={t("Tip Kodu")} selectedFilterOperation='contains' alignment='center' allowEditing={false} />
                    <Column dataField="type_name" caption={t("Tip Adı")} selectedFilterOperation='contains' alignment='center'>
                        <RequiredRule />
                    </Column>
                    <Column dataField="description" caption={t("Açıklama")} selectedFilterOperation='contains' alignment='center' />
                    <Column dataField="is_active" caption={t("Aktif")} dataType="boolean" selectedFilterOperation='contains' alignment='center' />

                    <Toolbar>
                        <Item name="addRowButton" />
                        <Item location="after">
                            <RxButton
                                color="light"
                                outline
                                onClick={fetchData}
                                style={{
                                    paddingInline: "10px",
                                    border: "1px solid #ddd"
                                }}
                            >
                                <i className="fa fa-refresh"></i>
                            </RxButton>
                            &nbsp;
                            <RxButton
                                className='btn btn-success'
                                style={{
                                    color: "white",
                                    paddingInline: "10px",
                                }}
                                onClick={(e) => ButtonOnExporting(e, ref, "Sevkiyat Tipleri")}>
                                <i className="fa fa-file-excel-o"></i>
                            </RxButton>
                        </Item>
                    </Toolbar>
                </DatagridCustom>
            </Card>
        </>
    );
};